// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1AaAs","calendarButtons":"ClockData_calendarButtons__1D-sk"};